import { Box } from "@mui/material";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

export default function BaseImage({ src, width = '100%', height = '100%', defaultSrc = '//ssl.gstatic.com/accounts/ui/avatar_2x.png', alt, sx, ...props}) {
  return (
    <Box sx={sx} {...props}>
      <LazyLoadImage 
        src={src || defaultSrc} 
        alt={alt}
        loading='lazy'
        width={width}
        height={height}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          ...props.sximage
        }}
        effect="blur"
        onError={(e) => {
          e.target.onError = null;
          e.target.src = defaultSrc
        }}
      />
    </Box>
  )
}